import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="25" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M8.547 6.82v10.36c0 .79.87 1.27 1.54.84l8.14-5.18a1 1 0 000-1.69l-8.14-5.17a.998.998 0 00-1.54.84z" fill="#fff" /></svg>;